<template>
  <div class="header-banner">
    <div class="header-banner-image">
    </div>
    <PictureReference src="LinguaSnapp"/>
  </div>
</template>

<script>

import PictureReference from '../misc/PictureReference';

export default {
    name: 'HeaderBanner',
    components: { PictureReference }
};
</script>

<style scoped>
.header-banner {
  position: relative;
  margin-top: 18px;
  margin-bottom: 24px;
  max-height: 464px;
}
.header-banner-image {
  padding-top: 18.26%;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('../../assets/images/banner/linguasnapp-banner-forschung.jpg');
  background-position: center;
}

@media all and (max-width: 1200px) {
  .header-banner-image {
    padding-top: 25%;
  }
}

@media all and (max-width: 640px) {
  .header-banner-image {
    background-image: url('../../assets/images/banner/banner-mobile.jpg');
  }
}

.header-banner img {
  height: 100%;
}
</style>
